import {
    DateRangeFilterRequest,
    EnumFilter,
    FilterRequest,
    StringFilter
} from '@lsq-frontend/remote-services/enterprise/common';
import { FilterType } from '../table/components/filters/constants/filter-types';
import { ColumnType } from '../table/constants/column-type';
import { ITableColumn } from '../table/models/table-column';

export class FilterHelper {
    /**
     * Based on a request and an array of columns, determine if any filters are set.
     */
    public static areAnyFiltersSet(
        columns: ITableColumn[],
        request: FilterRequest | DateRangeFilterRequest
    ): boolean {
        let areFiltersSet = false;
        areFiltersSet = columns.some(function (column) {
            if (column.type === ColumnType.Text) {
                if (
                    request[column.filterField] &&
                    (request[column.filterField] as StringFilter).value
                ) {
                    return true;
                }
            }

            if (
                column.type === ColumnType.Date ||
                column.type === ColumnType.DateTime ||
                column.type === ColumnType.Currency ||
                column.type === ColumnType.Number ||
                column.type === ColumnType.Percent ||
                column.type === ColumnType.Days
            ) {
                if (
                    request[column.filterField] &&
                    (request[column.filterField].fromValue !== null ||
                        request[column.filterField].toValue !== null)
                ) {
                    return true;
                }
            }

            if (column.type === ColumnType.Enum) {
                if (
                    request[column.filterField] &&
                    (request[column.filterField] as EnumFilter<number>).values &&
                    (request[column.filterField] as EnumFilter<number>).values.length
                ) {
                    return true;
                }
            }

            return false;
        });
        return areFiltersSet;
    }

    public static getFilterType(columnType: ColumnType): FilterType {
        if (
            columnType === ColumnType.Currency ||
            columnType === ColumnType.Number ||
            columnType === ColumnType.Percent
        ) {
            return FilterType.Float;
        }

        if (columnType === ColumnType.Date || columnType === ColumnType.DateTime) {
            return FilterType.Date;
        }

        if (columnType === ColumnType.Days) {
            return FilterType.Int;
        }

        if (columnType === ColumnType.Enum) {
            return FilterType.Enum;
        }

        if (columnType === ColumnType.Text || columnType === ColumnType.Address) {
            return FilterType.Text;
        }

        return null;
    }
}
